import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appHelper from '../../../helpers/appHelper';
import * as kpiHelper from '../../../helpers/kpiHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as kpiConstants from '../../../constants/kpiConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';

import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class RotationKpiMeter extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            kpiDefaults: this.props.kpiDefaults,
            userKpiResult: this.props.userKpiResult,
            meterParams: this.props.meterParams,
            feedback_styles: this.props.feedback_styles,
            showPointsIndicator: false,
            statusIndicatorClass: this.props.responseReview ? this.props.userKpiResult.statusIndicatorClass.class : "",
            svgExtensionClass: "",
            locale: {},
            guid: dataHelper.createGuid(),
            redrawMeter: false,
            kpiUpdate:{
                current:0,
                new:0,
                difference:0,
                type:""
            },
            getUpdateDifference: false,
            current_score_for_label: appHelper.getLocaleString("current_score_for_label"),
            start_label: appHelper.getLocaleString("start_label")
        };

        this.getLocale = this.getLocale.bind(this);
        this.renderSvg = this.renderSvg.bind(this);
        this.setSvgClass = this.setSvgClass.bind(this);
        this.setMeterRotation = this.setMeterRotation.bind(this);
        this.setDefaultMeterRotation = this.setDefaultMeterRotation.bind(this);
        this.updateMeterValues = this.updateMeterValues.bind(this);
        this.updateKpiClassValues = this.updateKpiClassValues.bind(this);
        this.updateMeterRotation = this.updateMeterRotation.bind(this);
        this.onRotationComplete = this.onRotationComplete.bind(this);
        this.getValue = this.getValue.bind(this);
        this.setUpdateDifference = this.setUpdateDifference.bind(this);
        this.getCurrentValue = this.getCurrentValue.bind(this);
    }

    componentDidMount() {
        if(appHelper.isDefined(this.state.userKpiResult.min)) {
            this.getLocale();
            this.renderSvg();
            if (this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_START) {
                this.setDefaultMeterRotation();
            } else {
                this.setMeterRotation();
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userKpiResult !== nextProps.userKpiResult || this.state.kpiDefaults !== nextProps.kpiDefaults) {
            let kpiUpdate = {
                current: this.state.userKpiResult.current,
                new: nextProps.userKpiResult.current
            };
            this.setState({
                statusIndicatorClass: "",
                kpiUpdate: Object.assign({},kpiUpdate),
                getUpdateDifference: true,
                userKpiResult: Object.assign({}, nextProps.userKpiResult),
                kpiDefaults: Object.assign({}, nextProps.kpiDefaults),
                redrawMeter: appHelper.isDefined(this.props.allowKpiRedraw) && this.props.allowKpiRedraw,
            });
            this.updateMeterValues(nextProps.userKpiResult);
        }
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.kpiDefaults),
                current_score_for_label: appHelper.getLocaleString("current_score_for_label"),
                start_label: appHelper.getLocaleString("start_label")
            });
        }
    }

    componentDidUpdate(){
        if(this.state.redrawMeter){
            this.getLocale();
            this.renderSvg();
            if(this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_START){
                this.setDefaultMeterRotation();
            }else{
                this.setMeterRotation();
            }
        }

        if(!this.state.redrawMeter && this.state.getUpdateDifference){
            this.setUpdateDifference();
        }
    }

    getLocale() {
        this.setState({locale: appHelper.getLocalData(this.state.kpiDefaults)});
    }

    renderSvg() {
        this.setState({redrawMeter: false});
        let redZone = this.refs[`kpiRedZone_${this.state.kpiDefaults.kpi_id}_${this.state.guid}`];
        let yellowZone = this.refs[`kpiYellowZone_${this.state.kpiDefaults.kpi_id}_${this.state.guid}`];
        let greenZone = this.refs[`kpiGreenZone_${this.state.kpiDefaults.kpi_id}_${this.state.guid}`];
        if(this.state.kpiDefaults.include_yellow) {
            redZone.setAttribute("d", kpiHelper.describeArc(
                this.state.meterParams.svgX,
                this.state.meterParams.svgY,
                this.state.meterParams.svgRadius,
                kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiDefaults.min, this.state.kpiDefaults.min, this.state.kpiDefaults.max),
                kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiDefaults.min, this.state.kpiDefaults.yellow, this.state.kpiDefaults.max)
            ));
            yellowZone.setAttribute("d", kpiHelper.describeArc(
                this.state.meterParams.svgX,
                this.state.meterParams.svgY,
                this.state.meterParams.svgRadius,
                kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiDefaults.min, this.state.kpiDefaults.yellow, this.state.kpiDefaults.max),
                kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiDefaults.min, this.state.kpiDefaults.green, this.state.kpiDefaults.max)
            ));
        }else{
            redZone.setAttribute("d", kpiHelper.describeArc(
                this.state.meterParams.svgX,
                this.state.meterParams.svgY,
                this.state.meterParams.svgRadius,
                kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiDefaults.min, this.state.kpiDefaults.min, this.state.kpiDefaults.max),
                kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiDefaults.min, this.state.kpiDefaults.green, this.state.kpiDefaults.max)
            ));
        }
        greenZone.setAttribute("d", kpiHelper.describeArc(
            this.state.meterParams.svgX,
            this.state.meterParams.svgY,
            this.state.meterParams.svgRadius,
            kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiDefaults.min, this.state.kpiDefaults.green, this.state.kpiDefaults.max),
            kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiDefaults.min, this.state.kpiDefaults.max, this.state.kpiDefaults.max)
        ));
    }

    updateMeterValues(updatedResult){
        let updateKpiClassValues = this.updateKpiClassValues;
        let index = 1000;
        if(appHelper.isDefined(this.props.index) ){
            index = (this.props.index + 1) * 1000;
        }
        setTimeout(function(){
            updateKpiClassValues(updatedResult);
        },index);


    }

    updateKpiClassValues(updatedResult){
        //if(appHelper.isDefined(updatedResult.statusIndicatorClass)){
        //this.setState({statusIndicatorClass: updatedResult.statusIndicatorClass.class});
        //this.setSvgClass(updatedResult.statusIndicatorClass.class);
        this.updateMeterRotation(updatedResult);
        //}
    }

    setMeterRotation() {
        let duration = 0;
        let rotator = this.refs[`rotator_${this.state.userKpiResult.kpi_id}_${this.state.guid}`];
        let rotationAngle = kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiDefaults.min, this.state.userKpiResult.current, this.state.kpiDefaults.max);

        TweenLite.to(rotator, duration, {
            rotation: rotationAngle + 'deg',
            ease: Expo.easeOut
        });
    }

    setDefaultMeterRotation() {
        let duration = 0;
        let rotator = this.refs[`rotator_${this.state.userKpiResult.kpi_id}_${this.state.guid}`];
        let rotationAngle = kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiDefaults.min, this.state.kpiDefaults.start, this.state.kpiDefaults.max);

        TweenLite.to(rotator, duration, {
            rotation: rotationAngle + 'deg',
            ease: Expo.easeOut
        });
    }

    updateMeterRotation(updatedResult) {
        let duration = objectConstants.KPI_ROTATION_DURATION;
        let rotator = this.refs[`rotator_${this.state.userKpiResult.kpi_id}_${this.state.guid}`];
        let rotationAngle = kpiHelper.getRotationAngle(this.state.meterParams.maxRotation, this.state.kpiDefaults.min, updatedResult.current, this.state.kpiDefaults.max);

        TweenLite.to(rotator, duration, {
            rotation: rotationAngle + 'deg',
            ease: Expo.easeOut,
            delay: 0.5,
            onComplete: this.onRotationComplete,
            onCompleteParams: [updatedResult]
        });
    }

    onRotationComplete(params) {
        if(appHelper.isDefined(this.props.onRotationComplete)){
            this.props.onRotationComplete(this.state.userKpiResult.kpi_id);
        }
    }



    setSvgClass(pointIndicatorClass) {
        if (this.props.showImmediateImpact && pointIndicatorClass === "no-value") {
            this.setState({svgExtensionClass: "no-value"});
        }

    }

    getValue(){
        if(appHelper.isDefined(this.state.kpiDefaults.decimals)){
            //if(this.state.userKpiResult.current)
            return Number(this.state.userKpiResult.current).toFixed(this.state.kpiDefaults.decimals);
        }else{
            Number(this.state.userKpiResult.current).toFixed(0);
        }
    }

    setUpdateDifference(){
        this.setState({getUpdateDifference: false});
        let decimal_points = parseFloat(this.state.kpiDefaults.decimals_points);

        if(this.state.kpiUpdate.new > this.state.kpiUpdate.current){
            this.setState({
                kpiUpdate: Object.assign({},this.state.kpiUpdate,{
                    difference: decimal_points === 0 ? this.state.userKpiResult.value.toFixed(2) : this.state.userKpiResult.value.toFixed(decimal_points),
                    type: 'positive',
                })
            });
        }else if(this.state.kpiUpdate.current > this.state.kpiUpdate.new){
            let difference = Math.abs(this.state.userKpiResult.value);
            this.setState({
                kpiUpdate: Object.assign({},this.state.kpiUpdate,{
                    difference: decimal_points === 0 ? Math.abs(this.state.userKpiResult.value).toFixed(2) : Math.abs(this.state.userKpiResult.value).toFixed(decimal_points),
                    type: 'negative',
                })
            });
        }else{
            this.setState({
                kpiUpdate: Object.assign({},this.state.kpiUpdate,{
                    difference: 0,
                    type: 'neutral',
                })
            });
        }

    }

    getCurrentValue(){
        let decimal_points = parseFloat(this.state.kpiDefaults.decimals_points);
        /*if(decimal_points === 0){
            console.log(this.state.userKpiResult.current);
            return  Math.floor(this.state.userKpiResult.current);
        }else{
            return this.state.userKpiResult.current.toFixed(this.state.kpiDefaults.decimals_points);
        }*/
        return this.state.userKpiResult.current.toFixed(decimal_points);
    }

    render() {
        return (
            appHelper.isDefined(this.state.userKpiResult.min)
            ?
            <div className={` ${this.state.meterParams.className}`} role="presentation">
                {
                    this.state.kpiUpdate.difference !== 0 && !this.props.allowKpiRedraw
                        ?
                        <div className={`kpi-score-difference ${this.state.kpiUpdate.type}`}  role="presentation"><span className="diff-label"><span className={`${this.state.kpiUpdate.type}`}><span className={`${this.state.kpiDefaults.unit_type}`}>{this.state.kpiUpdate.difference}</span></span></span></div>
                        :
                        null
                }

                <div className="kpi-rotation-meter">
                    <div className="meter-wrapper">
                        {
                            this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_START
                                ?
                                <div className={`min-label ${kpiHelper.getKpiScoreRange(this.state.kpiDefaults,this.state.kpiDefaults.min)}`} role="presentation"><span className={`${this.state.kpiDefaults.unit_type}`}>{this.state.kpiDefaults.min.toFixed(this.state.kpiDefaults.decimals_points)}</span></div>
                                :
                                null
                        }
                        <svg className={`kpi-svg ${this.state.svgExtensionClass}`} role="presentation">
                            <path ref={`kpiRedZone_${this.state.kpiDefaults.kpi_id}_${this.state.guid}`} fill="none"
                                  strokeWidth={this.state.meterParams.svgStroke}
                                  stroke={this.state.feedback_styles.red_feedback.colors.color} role="presentation"/>
                            {this.state.kpiDefaults.include_yellow
                                ?

                                <path ref={`kpiYellowZone_${this.state.kpiDefaults.kpi_id}_${this.state.guid}`}
                                      fill="none"
                                      strokeWidth={this.state.meterParams.svgStroke}
                                      stroke={this.state.feedback_styles.yellow_feedback.colors.color}
                                      role="presentation"/>
                                :
                                null
                            }
                            <path ref={`kpiGreenZone_${this.state.kpiDefaults.kpi_id}_${this.state.guid}`} fill="none"
                                  strokeWidth={this.state.meterParams.svgStroke}
                                  stroke={this.state.feedback_styles.green_feedback.colors.color} role="presentation"/>
                        </svg>
                        <div className="rotator" ref={`rotator_${this.state.kpiDefaults.kpi_id}_${this.state.guid}`} role="presentation"/>
                        {
                            this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_START
                                ?
                                <div className={`max-label ${kpiHelper.getKpiScoreRange(this.state.kpiDefaults,this.state.kpiDefaults.max)}`} role="presentation"><span className={`${this.state.kpiDefaults.unit_type}`}>{this.state.kpiDefaults.max.toFixed(this.state.kpiDefaults.decimals_points)}</span></div>
                                :
                                null
                        }
                    </div>
                </div>
                {this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_CURRENT_POINTS_AWARDED || this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_REVIEW_POINTS_AWARDED || this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_START
                    ? <div className={`kpi-points-awarded ${this.state.statusIndicatorClass} guroo-kpi-label`}>{this.state.locale.short_title}</div>
                    : null
                }

                {this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_WITH_LABEL || this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL
                    ? <div className="kpi-current-score"><span className={`current-score-label ${this.state.userKpiResult.currentScoreRange} ${this.state.kpiDefaults.unit_type}`}><span className="hidden-el">{this.state.current_score_for_label} {this.state.locale.short_title}:</span>{this.getCurrentValue()}<span className="hidden-el"> {appHelper.getLocaleString("out_of_label")} {this.state.kpiDefaults.max}</span></span></div>
                    : null
                }
                {
                    this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_WITH_LABEL
                        ? <div className="kpi-label">{this.state.locale.short_title}</div>
                        : null
                }
                {
                    this.props.displayState === kpiConstants.KPI_DISPLAY_STATE_START
                        ?
                        <div className={`start-label ${kpiHelper.getKpiScoreRange(this.state.kpiDefaults,this.state.kpiDefaults.start)}`} role="presentation">{this.state.start_label}: <span className={`${this.state.kpiDefaults.unit_type}`}>{this.state.kpiDefaults.start.toFixed(this.state.kpiDefaults.decimals_points)}</span></div>
                        :
                        null
                }


            </div>
                :
                null
        );
    }
}

RotationKpiMeter.propTypes = {
    userKpiResult: PropTypes.object.isRequired,
    kpiDefaults: PropTypes.object.isRequired,
    meterParams: PropTypes.object.isRequired,
    feedback_styles: PropTypes.object.isRequired,
    displayState: PropTypes.string,
    responseReview: PropTypes.bool,
    bite_id: PropTypes.number,
    screen_id: PropTypes.number,
    asset_id: PropTypes.number,
    option_id: PropTypes.number,
    showImmediateImpact: PropTypes.bool,
    onMeterClicked: PropTypes.func,
    index: PropTypes.number,
    onRotationComplete: PropTypes.func,
    lang: PropTypes.string.isRequired,
    allowKpiRedraw: PropTypes.bool
};

RotationKpiMeter.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {

    let userBite = appHelper.getArrayObjectByKey(state.userData.bites, "bite_id", ownProps.bite_id);
    let userKpiResult = appHelper.getArrayObjectByKey(userBite.kpis, "kpi_id", ownProps.kpiDefaults.kpi_id);
    if (ownProps.responseReview) {
        userKpiResult = Object.assign({}, kpiHelper.getKpiUserResponse(userKpiResult, ownProps.screen_id, ownProps.asset_id, ownProps.option_id));
    }
    let lang = state.userData.lang;

    return {
        lang:lang,
        userKpiResult: userKpiResult,
        feedback_styles: state.contentData.experience.feedback_styles,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, appDataActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(RotationKpiMeter);



/** WEBPACK FOOTER **
 ** ./src/components/objects/kpi/RotationKpiMeter.js
 **/